import React from "react";
import { mdiTrayArrowUp, mdiCellphone, mdiShimmer } from "@mdi/js";
import HowItWorksModal from "app/components/common/HowItWorksModal";

const ROWS = [
  {
    icon: mdiTrayArrowUp,
    title: "Create Template",
    body: (
      <p>
        Import Spectora XLS files to create templates.
        <br />
        The system automatically extracts sections and adds narratives to your
        library.
      </p>
    ),
  },
  {
    icon: mdiCellphone,
    title: "Using Templates in the Mobile App",
    body: (
      <p>
        Choose a template when starting a project.
        <br />
        AI will automatically organize your notes into the right sections.
      </p>
    ),
  },
  {
    icon: mdiShimmer,
    title: "AI Narrative Enhancement",
    body: (
      <p>
        AI references your narrative library to generate accurate and
        professional results from your notes and photos.
      </p>
    ),
  },
];

const TemplatesHowItWorksModal = ({ show, onHide }) => (
  <HowItWorksModal
    show={show}
    onHide={onHide}
    title="How Smart Template Works"
    rows={ROWS}
  />
);

export default TemplatesHowItWorksModal;
